import { isEqual } from 'lodash';

import {
  DatabaseWearable,
  DatabaseWearableWithOwner,
} from '@repo/types-client';

export const compareSelection = (
  item: DatabaseWearableWithOwner,
  selectedItem: DatabaseWearable,
) => {
  const hasSameId = isEqual(item.id, selectedItem?.id);
  const selectedItemTokenId = (selectedItem as DatabaseWearableWithOwner)
    ?.tokenId;

  if (!selectedItemTokenId) {
    return hasSameId;
  }

  const hasSameTokenId = isEqual(item.tokenId, selectedItemTokenId);

  return hasSameId && hasSameTokenId;
};

export const checkIfSelected = ({
  item,
  isMultiSelect,
  currentSelectedItem,
  currentSelectedItems,
}: {
  item: DatabaseWearableWithOwner;
  isMultiSelect?: boolean;
  currentSelectedItem?: DatabaseWearable;
  currentSelectedItems?: DatabaseWearable[];
}) => {
  if (isMultiSelect) {
    return (
      currentSelectedItems?.some((selectedItem) =>
        compareSelection(item, selectedItem as DatabaseWearable),
      ) || false
    );
  }

  return compareSelection(item, currentSelectedItem as DatabaseWearable);
};
